
import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { updateRouteItem } from "../../../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .box{
        width: 22px;
        height: 22px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};
        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: 1.2rem;
            fill: ${({theme}) => theme.mainTextColor};
        }
    }

    .label{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
    }
`

const KayitliAdreslerimeEkleCheckbox = ({data}) => {

    const dispatch = useDispatch()

  return (
    <Container>
        <div className="box" onClick={() => dispatch(updateRouteItem({id: data.id, adresKaydedilsinMi: !data.adresKaydedilsinMi}))}>{data.adresKaydedilsinMi && <GoCheck className="check-icon"/>}</div>
        <div className="label">Kayıtlı Adreslerime Ekle</div>
    </Container>
  )
}

export default KayitliAdreslerimeEkleCheckbox